import {useEffect, useRef, useState} from "react";

export function TabbedContent({tabHeaders, children, defaultActive = 0, removeContent = true, onTabChange=()=>{}}) {
    const [activeTab, setActiveTab] = useState(defaultActive);
    const isInitialMount = useRef(true);

    useEffect(()=>{
        if(isInitialMount.current){
            isInitialMount.current = false;
        }
        else{
            onTabChange();
        }
    }, [activeTab])

    return <>
        <ul className="nav nav-pills">
            {
                tabHeaders?.map((header, index) => {
                    return <li key={index} className={index === activeTab ? "active" : ""}
                               onClick={() => setActiveTab(index)}>
                        {header}
                    </li>
                })
            }
        </ul>

        <div className="tab-content">
            {
                removeContent ?
                    children?.map((child, index) => {
                        return index === activeTab && child;
                    })
                    :
                    children?.map((child, index) => {
                        return <div key={index} style={{display: (index === activeTab ? "block" : "none")}}>
                            {child}
                        </div>
                    })
            }
        </div>
    </>
}